module.exports = __webpack_public_path__ + "static/media/YB5F17_5.b974bde7.jpg";